module.exports = __webpack_public_path__ + "static/media/girl.557da3e3.jpg";